import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { QueryBuilderFactory } from '@bingads-webui-campaign/query-builder';
import { connect } from '@bingads-webui-campaign/dqb-grid-datasource-connector';
import { DataSourceStore } from '@bingads-webui-campaign/data-source-store';
import { GENERAL_INSIGHTS_DATA_TYPES, GeneralInsightsSegmentationDecorator } from '@bingads-webui-campaign-react/competition-core';
import { getPillControlDecorator } from './pill-control-decorator';

const appState = globalContext.require('component/state/index');
const dateUtil = globalContext.require('component/humanize/date');
const SegmentationPreference = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const { fetchSortInfo } = globalContext.require('component/bingads-grid/service/fetch-sortinfo');
const preferencesService = globalContext.requireDefault('component/preference/service/index');

export function initializeDataSource({
  type = GENERAL_INSIGHTS_DATA_TYPES.Grid,
  dataService,
  filterService = null,
  featureName,
  afterFindAll,
}) {
  const isType = (...types) => _.contains(types, type);
  const { Chart, Tile, Grid } = GENERAL_INSIGHTS_DATA_TYPES;

  const queryBuilderConfig = {
    decorators: _.compact([
      { name: 'dateFilter' },
      isType(Chart, Grid) && { name: 'segment' },
      isType(Chart, Grid) && { name: 'filter', filterService },
      isType(Chart, Grid) && { name: 'sorting' },
      isType(Chart, Grid) && getPillControlDecorator(preferencesService),
      isType(Chart, Tile) && new GeneralInsightsSegmentationDecorator(type === Tile),
    ]),
    commonConfig: {
      featureName,
      isOdataActionSource: false,
      deps: {
        dateUtil,
        state: appState,
        SegmentationPreference,
        fetchSortInfo,
      },
    },
  };

  const queryBuilder = QueryBuilderFactory.make(queryBuilderConfig);
  const dataSource = connect(
    {
      type: 'jsdata',
      entity: dataService,
      options: {
        useDfmCache: true,
        afterFindAll: isType(Grid) ? afterFindAll : _.noop,
      },
    },
    queryBuilder,
    type
  );

  // Prefetch
  dataSource.query();

  DataSourceStore.set(type, dataSource);
}

export function initializeDataSources({
  dataService,
  filterService,
  featureName,
  afterFindAll,
}) {
  initializeDataSource({
    type: GENERAL_INSIGHTS_DATA_TYPES.Grid,
    dataService,
    filterService,
    featureName,
    preferencesService,
    afterFindAll,
  });
  initializeDataSource({
    type: GENERAL_INSIGHTS_DATA_TYPES.Chart,
    dataService,
    filterService,
    featureName,
    preferencesService,
  });
}

export function getDataSource(type = GENERAL_INSIGHTS_DATA_TYPES.Grid) {
  return DataSourceStore.get(type);
}
